<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" v-model="email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button v-on:click="signIn" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { auth } from '@/config/devowqlo';

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''

    }
  },
  created: {
    initApp() {
      // Listening for auth state changes.
      // [START authstatelistener]
      auth.onAuthStateChanged(function(user) {

        console.log(signedIn)
        if (user) {
          user.getIdToken().then(function(data) {
            console.log(data)
              if(data.claims["superadmin"]){
                //Go to main page
                console.log("go to main page")
              }else{
                this.email = ''
                this.password = ''
              }
          });
        }
      });
    }
  },
  methods: {
    signIn(){
      auth.signInWithEmailAndPassword(this.email, this.password).catch(error => console.log(error))
    },
    
  }
}



</script>
